import { Component, OnInit } from '@angular/core';

import { map, Observable, switchMap } from 'rxjs';
import { Store } from '@ngrx/store';

import { CmsCollection, CmsTeaser } from '@fcom/core-api/interfaces';
import { CmsDataService } from '@fcom/core/services';
import { LanguageService } from '@fcom/ui-translate/services/language.service';
import { AppState } from '@fcom/core/interfaces';
import { profileOrUndefinedIfNotLoggedIn } from '@fcom/core/selectors';
import { MediaQueryService } from '@fcom/common/services';
import { CorporateUserRole } from '@fcom/core-api/login';
import { QuickLink } from '@fcom/ui-components';

@Component({
  selector: 'fin-quick-links',
  templateUrl: './quick-links.component.html',
  styleUrl: './quick-links.component.scss',
})
export class CorporateQuickLinksComponent implements OnInit {
  links$: Observable<QuickLink[]>;
  isMobile$: Observable<boolean>;

  constructor(
    private languageService: LanguageService,
    private cmsDataService: CmsDataService,
    private mediaQueryService: MediaQueryService,
    private store$: Store<AppState>
  ) {}

  ngOnInit(): void {
    this.links$ = this.store$.pipe(profileOrUndefinedIfNotLoggedIn()).pipe(
      map((userProfile) => {
        switch (userProfile?.corporate?.userRole) {
          case CorporateUserRole.ADMIN:
          case CorporateUserRole.TRAVEL_BOOKER:
            return 'CORPORATE.fragments.corporatePortal.adminQuickLinks.url';
          case CorporateUserRole.TRAVELLER:
            return 'CORPORATE.fragments.corporatePortal.travellerQuickLinks.url';
          default:
            return 'CORPORATE.fragments.corporatePortal.defaultQuickLinks.url';
        }
      }),
      switchMap((key) => this.languageService.translate(key)),
      switchMap((url) => this.cmsDataService.getFragmentJson<CmsCollection>(url)),
      map((fragment) => fragment.items as CmsTeaser[]),
      map((items) =>
        items.map((item) => ({
          title: item.teaserTitle,
          iconName: item.localSettings?.iconName,
          url: item.target?.url,
          external: item.target?.external,
        }))
      )
    );
    this.isMobile$ = this.mediaQueryService.isBreakpoint$('mobile');
  }
}
